export const namespaced = true;

export const state = {
    types: [],
    elements: [],
    loadingElements: {}
};

export const mutations = {
    FETCH_TYPES(state, types) {
        state.types = types;
    },
    FETCH_ELEMENTS(state, elements) {
        state.elements = elements;
    },
    SET_TYPE_SHOW_ELEMENTS(state, { typeId, show }) {
        const typeIndex = state.types.findIndex(t => t.type_id == typeId);
        if (typeIndex >= 0) {
            state.types[typeIndex].showElements = show;
            state.types = [...state.types];
        }
    },

    SET_TYPE_ELEMENTS(state, { typeId, elements }) {
        const typeIndex = state.types.findIndex(t => t.type_id == typeId);
        if (typeIndex >= 0) {
            if (state.types[typeIndex].elements.length) {
                elements.forEach(element => {
                    state.types[typeIndex].elements.push(element);
                });
            } else {
                state.types[typeIndex].elements = elements;
            }

            state.types = [...state.types];
        }
    },

    CLEAR_TYPE_ELEMENTS(state, typeId) {
        const typeIndex = state.types.findIndex(t => t.type_id == typeId);
        if (typeIndex >= 0) {
            state.types[typeIndex].elements = [];
            state.types = [...state.types];
        }
    },

    SET_TYPE_META(state, { typeId, meta }) {
        const typeIndex = state.types.findIndex(t => t.type_id == typeId);
        if (typeIndex >= 0) {
            state.types[typeIndex].meta = meta;
            state.types = [...state.types];
        }
    },

    SET_LOADING_ELEMENTS(state, { typeId, loading }) {
        state.loadingElements[typeId] = loading;
    }
};

export const actions = {
    async fetch({ commit, state, dispatch, rootGetters }, element_group) {
        commit('SET_ELEMENT_GROUP', element_group);
        try {
            const res = (
                await axios.get(`/api/element_groups/${element_group}`)
            ).data;
            commit("FETCH_TYPES", res.data.element_group.types);
            commit("FETCH_ELEMENTS", res.data.elements);

            const selected = rootGetters["clientOrder/selectedElement"](
                element_group
            );

            if (selected) {
                // dispatch("getElementsByType", selected.type_id);
                dispatch("clearTypeElements", selected.type_id);
                dispatch("setTypeShowElements", {
                    typeId: selected.type_id,
                    show: true
                });
            }
        } catch (error) {
            const notification = {
                element: "error",
                message:
                    error.response &&
                    error.response.data &&
                    error.response.data.message
            };
            dispatch("notification/add", notification, { root: true });
        }
    },

    setTypeShowElements({ commit }, { typeId, show }) {
        commit("SET_TYPE_SHOW_ELEMENTS", { typeId, show });
    },

    clearTypeElements({ commit }, typeId) {
        commit("CLEAR_TYPE_ELEMENTS", typeId);
        commit("SET_TYPE_META", { typeId, meta: null });
    },

    async getElementsByType({ commit, dispatch, state, rootState }, typeId) {
        commit("SET_LOADING_ELEMENTS", { typeId, loading: true });
        let page = 1;
        const type = state.types.find(t => t.type_id == typeId);
        if (type && type.meta && type.meta.current_page) {
            page = type.meta.current_page + 1;
        }
        try {
            const res = (
                await axios.get(`/api/type-elements/${typeId}`, {
                    params: {
                        per_page:
                            parseInt(
                                rootState.settings.settings
                                    .count_elements_configurator
                            ) || 24,
                        page
                    }
                })
            ).data;
            commit("SET_TYPE_ELEMENTS", { typeId, elements: res.data });
            commit("SET_TYPE_META", { typeId, meta: res?.meta });
        } catch (error) {
            const notification = {
                element: "error",
                message:
                    error.response &&
                    error.response.data &&
                    error.response.data.message
            };
            dispatch("notification/add", notification, { root: true });
        } finally {
            commit("SET_LOADING_ELEMENTS", { typeId, loading: false });
        }
    },
    selectElement({ dispatch }, selectedElement) {

        dispatch("clientOrder/addElement", selectedElement, { root: true });

        dispatch(
            "clientOrder/updateElementSize",
            {
                element_id: selectedElement.element_id,
                size: selectedElement.sizes[0]
            },
            { root: true }
        );

        if (selectedElement.type_calc_cost !== 'fix' && selectedElement.materials.length) {
            dispatch(
                "clientOrder/updateElementMaterial",
                {
                    element_id: selectedElement.element_id,
                    material: selectedElement.materials[0]
                },
                { root: true }
            );
        }
    }
};
